// Lightweight i18n — English + Hindi for UI shell.
// LLM-generated content (nakshatra themes, mission text, daily cards) stays in English for now.

const STRINGS = {
  en: {
    // Welcome
    "welcome.tagline": "Walk your life with awareness.",
    "welcome.subtitle": "A contemplative companion through\nthe Vedic chapters of your life.",
    "welcome.google": "Continue with Google",
    "welcome.terms": "By continuing, you agree to our",
    "welcome.privacy": "Privacy Policy",
    "welcome.tos": "Terms",

    // Nav
    "nav.today": "Today",
    "nav.mission": "Mission",
    "nav.journey": "Journey",
    "nav.progress": "Progress",
    "nav.menu": "Menu",
    "nav.back": "Back",

    // Today
    "today.day_of_chapter": "Day {n} of your current chapter",
    "today.trial": "Free trial",
    "today.days": "days",
    "today.nakshatra": "Today's nakshatra",
    "today.within_mission": "Within your mission today",
    "today.watch": "Today's watch",
    "today.reflection": "Today's reflection",
    "today.answer_journal": "Answer in your journal",
    "today.current_antardasha": "Current Antardasha",
    "today.days_remaining": "{n} days remaining",
    "today.open_mission": "Open mission",
    "today.from_journal": "From your journal",
    "today.open_journal": "Open my journal",
    "today.empty_journal": "Nothing here yet. The first page is the hardest.",

    // Journey
    "journey.title": "Your Journey",
    "journey.days_walked": "{n} days walked",
    "journey.currently_in": "Currently in",
    "journey.mahadasha_map": "Mahadasha Phase Map",
    "journey.mahadasha_map_sub": "Your full life arc — 9 Mahadashas",
    "journey.antardasha_map": "Antardasha Phase Map",
    "journey.antardasha_map_sub": "The 9 sub-periods inside your current chapter",
    "journey.journal": "Personal Journal",
    "journey.journal_sub": "{n} entries",
    "journey.discovery": "Discovery Cards",
    "journey.discovery_sub": "{a} of {b} revealed",
    "journey.resonances": "Resonances",
    "journey.resonances_sub": "{a} of {b} figures",
    "journey.completed": "Completed Chapters",
    "journey.completed_sub": "Past Antardashas walked",

    // Journal
    "journal.title": "Personal Journal",
    "journal.your_journey": "Your Journey",
    "journal.entries": "{n} entries",
    "journal.empty_title": "The first page",
    "journal.empty_body": "What you notice today becomes what you remember years from now. Tap the gold + to begin.",
    "journal.add": "Add to your journey",
    "journal.short_title": "A short title (optional)",
    "journal.write_prompt": "What is worth remembering today?",
    "journal.cancel": "Cancel",
    "journal.save": "Save",
    "journal.saved": "Added to your journal",

    // Phase Map
    "phasemap.mahadasha_title": "Mahadasha Phase Map",
    "phasemap.mahadasha_sub": "Your full life arc — 9 Mahadashas",
    "phasemap.antardasha_title": "Antardasha Phase Map",
    "phasemap.antardasha_sub": "9 sub-periods within {planet} Mahadasha",
    "phasemap.current": "Current",
    "phasemap.years": "years",
    "phasemap.tap_details": "Tap any card for details",

    // Mahadasha / Antardasha detail
    "detail.what_asks": "What this period asks",
    "detail.watch_for": "Watch for",
    "detail.favors": "This phase favors",
    "detail.duration": "Duration",
    "detail.start": "Started",
    "detail.end": "Ends",
    "detail.years_word": "years",
    "detail.days_word": "days",
    "detail.you_are_here": "You are here",

    // Mission
    "mission.your_mission": "Your Mission",
    "mission.progress": "Progress",
    "mission.duration": "Duration",
    "mission.milestones": "milestones",
    "mission.days": "days",
    "mission.complete_subtask": "Mark sub-task complete",
    "mission.saving": "Saving…",
    "mission.complete_title": "Mission complete",
    "mission.complete_sub": "You walked the full path. Rest before the next chapter.",
    "mission.step": "Step",

    // Menu
    "menu.title": "Settings",
    "menu.account": "Account",
    "menu.subscription": "Subscription",
    "menu.preferences": "Preferences",
    "menu.privacy": "Privacy & Data",
    "menu.about": "About Vedari",
    "menu.plan": "Plan",
    "menu.plan_value": "Free trial",
    "menu.trial_ends": "Trial ends in",
    "menu.upgrade": "Upgrade",
    "menu.coming_soon": "Coming soon",
    "menu.plan_active_monthly": "Vedari Monthly",
    "menu.plan_active_yearly": "Vedari Yearly",
    "menu.plan_reviewer": "Reviewer access",
    "menu.plan_expired": "Trial ended",
    "menu.renews_on": "Renews on",
    "menu.ends_on": "Access until",
    "menu.subscribe_now": "Subscribe",
    "menu.see_plans": "See plans",
    "menu.manage_play": "Manage in Play Store",
    "menu.subscribed_to": "Subscribed",
    "menu.auto_renew_on": "Auto-renew on",
    "menu.auto_renew_off": "Auto-renew off",
    "menu.theme": "Theme",
    "menu.language": "Language",
    "menu.notifications": "Notifications",
    "menu.email_only": "Email only",
    "menu.export_data": "Export my data",
    "menu.export_pdf": "Export journal as PDF",
    "menu.delete": "Delete my account",
    "menu.approach": "Our approach",
    "menu.privacy_link": "Privacy Policy",
    "menu.terms": "Terms of Service",
    "menu.version": "App version",
    "menu.signout": "Sign out",
    "menu.theme_light": "Light",
    "menu.theme_dark": "Dark",

    // Today's Practice
    "practice.heading": "Today's Practice",
    "practice.mark_done": "Mark as done",
    "practice.done": "Done",
    "practice.minutes": "{n} minutes",
    "practice.streak": "{n} day streak",
    "practice.ack": "{n} days. Quietly remarkable.",

    // Personalized phase
    "phase.what_asks": "What this period asks of you",
    "phase.how_to_walk": "How to walk it well",
    "phase.critical_window": "The critical window",
    "phase.protect": "What to protect",
    "phase.build": "What to build",
    "phase.how_showing_up": "How it's showing up for you",
    "phase.theme": "Theme",
    "phase.refreshed": "Your understanding of this chapter has deepened.",

    // Progress — practices
    "progress.practices": "Your Practices",
    "progress.current_streak": "Current streak",
    "progress.longest_streak": "Longest streak",
    "progress.total_completed": "Total completed",
    "progress.recent_practices": "Recent practices",
    "progress.by_category": "By category",
    "progress.cat_morning": "Morning",
    "progress.cat_day_of_week": "Day-aligned",
    "progress.cat_phase": "Phase-aligned",
    "progress.cat_evening": "Evening",
    "progress.cat_weekly": "Weekly",
    "progress.cat_seasonal": "Seasonal",

    // Onboarding — Profile
    "ob.profile.title": "A little about you",
    "ob.profile.sub": "These details help us greet you properly. Nothing here is shared.",
    "ob.profile.name": "Name",
    "ob.profile.name_ph": "Your name",
    "ob.profile.age": "Age",
    "ob.profile.age_ph": "Years",
    "ob.profile.gender": "Gender",
    "ob.profile.gender.male": "Male",
    "ob.profile.gender.female": "Female",
    "ob.profile.gender.nb": "Prefer not to say",
    "ob.profile.marital": "Marital status",
    "ob.profile.marital.single": "Single",
    "ob.profile.marital.married": "Married",
    "ob.profile.marital.divorced": "Divorced",
    "ob.profile.marital.widowed": "Widowed",
    "ob.profile.marital.separated": "Separated",
    "ob.profile.children": "Children",
    "ob.profile.children_yes": "Yes, I have children",
    "ob.profile.children_count_ph": "How many?",
    "ob.profile.city": "City",
    "ob.profile.city_ph": "Your city",
    "ob.profile.profession": "Profession (optional)",
    "ob.profile.profession_ph": "What you do",
    "ob.profile.language_prompt": "Language",

    // Onboarding — Priorities
    "ob.prio.title": "What do you want to walk with?",
    "ob.prio.sub_a": "Choose up to",
    "ob.prio.sub_b": ". Three is a good number to start with.",
    "ob.prio.count": "{a} of 5 selected",

    // Onboarding — DeepDive
    "ob.dive.of": "of",
    "ob.dive.sub": "Three short questions. Be honest, not careful.",
    "ob.dive.rate_label": "How would you rate this area today?",
    "ob.dive.rate_low": "Struggling",
    "ob.dive.rate_high": "Thriving",
    "ob.dive.heart_label": "What's at the heart of it?",
    "ob.dive.note_label": "Anything else worth saying?",
    "ob.dive.note_opt": "(optional)",
    "ob.dive.note_ph": "A sentence or two",

    // Onboarding — Life Letter
    "ob.letter.title": "Before we read your chart, tell us what's actually going on.",
    "ob.letter.sub": "The more Vedari knows about your life right now, the more specific your guidance will be. Write as much or as little as you want — all three questions are optional.",
    "ob.letter.q1_label": "What's your life like right now?",
    "ob.letter.q1_helper": "Work, relationships, family, health, finances, mood — whatever feels true today.",
    "ob.letter.q2_label": "What's the hardest thing you're facing?",
    "ob.letter.q2_helper": "The thing that wakes you up at 3am. The conversation you keep avoiding. The decision you can't make.",
    "ob.letter.q3_label": "Where do you want to be a year from now?",
    "ob.letter.q3_helper": "Not goals on a list — the actual shape of a life that would feel like you've grown.",
    "ob.letter.privacy": "Everything you write stays private. Vedari uses it only to make your guidance specific to you. You can edit or delete this anytime from Settings.",
    "ob.letter.saving": "Saving…",
    "ob.letter.skip": "I'll add this later",
    "ob.letter.ph": "Write here, or skip…",

    // Onboarding — Birth
    "ob.birth.title": "Your birth details",
    "ob.birth.sub": "Used to compute your Vedic chart. Encrypted at rest. Never shared.",
    "ob.birth.dob": "Date of birth",
    "ob.birth.tob": "Time of birth",
    "ob.birth.time_unknown": "I'm not sure of exact time",
    "ob.birth.time_warning": "Approximate birth time reduces precision of phase boundaries. Your chart will still work — some insights will be less precise.",
    "ob.birth.place": "Place of birth",
    "ob.birth.place_ph": "City, country",
    "ob.birth.preparing": "Preparing your map…",
    "ob.birth.reveal": "Reveal My Vedic Map",
    "ob.birth.cant_save": "Could not save your details. Please try again.",

    // Common
    "common.continue": "Continue",
    "common.back": "Back",
    "common.moment": "A moment…",
  },

  hi: {
    "welcome.tagline": "अपना जीवन सजगता से जिएँ।",
    "welcome.subtitle": "आपके जीवन के वैदिक अध्यायों में\nएक चिंतनशील साथी।",
    "welcome.google": "Google के साथ जारी रखें",
    "welcome.terms": "जारी रखते हुए, आप हमारी",
    "welcome.privacy": "गोपनीयता नीति",
    "welcome.tos": "नियमों",

    "nav.today": "आज",
    "nav.mission": "मिशन",
    "nav.journey": "यात्रा",
    "nav.progress": "प्रगति",
    "nav.menu": "मेनू",
    "nav.back": "वापस",

    "today.day_of_chapter": "आपके वर्तमान अध्याय का दिन {n}",
    "today.trial": "नि:शुल्क परीक्षण",
    "today.days": "दिन",
    "today.nakshatra": "आज का नक्षत्र",
    "today.within_mission": "आज आपके मिशन के भीतर",
    "today.watch": "आज की दृष्टि",
    "today.reflection": "आज का चिंतन",
    "today.answer_journal": "अपनी डायरी में उत्तर दें",
    "today.current_antardasha": "वर्तमान अंतर्दशा",
    "today.days_remaining": "{n} दिन शेष",
    "today.open_mission": "मिशन खोलें",
    "today.from_journal": "आपकी डायरी से",
    "today.open_journal": "मेरी डायरी खोलें",
    "today.empty_journal": "अभी यहाँ कुछ नहीं। पहला पन्ना सबसे कठिन होता है।",

    "journey.title": "आपकी यात्रा",
    "journey.days_walked": "{n} दिन चले",
    "journey.currently_in": "वर्तमान में",
    "journey.mahadasha_map": "महादशा फेज़ मानचित्र",
    "journey.mahadasha_map_sub": "आपके जीवन की पूरी रेखा — 9 महादशाएँ",
    "journey.antardasha_map": "अंतर्दशा फेज़ मानचित्र",
    "journey.antardasha_map_sub": "आपके वर्तमान अध्याय के 9 उप-काल",
    "journey.journal": "व्यक्तिगत डायरी",
    "journey.journal_sub": "{n} प्रविष्टियाँ",
    "journey.discovery": "अनावरण कार्ड",
    "journey.discovery_sub": "{b} में से {a} प्रकट",
    "journey.resonances": "अनुनाद",
    "journey.resonances_sub": "{b} में से {a} व्यक्तित्व",
    "journey.completed": "पूर्ण अध्याय",
    "journey.completed_sub": "बीती हुई अंतर्दशाएँ",

    "journal.title": "व्यक्तिगत डायरी",
    "journal.your_journey": "आपकी यात्रा",
    "journal.entries": "{n} प्रविष्टियाँ",
    "journal.empty_title": "पहला पन्ना",
    "journal.empty_body": "आज जो देखेंगे वही वर्षों बाद याद रहेगा। शुरू करने के लिए सुनहरे + पर टैप करें।",
    "journal.add": "अपनी यात्रा में जोड़ें",
    "journal.short_title": "एक छोटा शीर्षक (वैकल्पिक)",
    "journal.write_prompt": "आज क्या याद रखने योग्य है?",
    "journal.cancel": "रद्द करें",
    "journal.save": "सहेजें",
    "journal.saved": "डायरी में जोड़ा गया",

    "phasemap.mahadasha_title": "महादशा फेज़ मानचित्र",
    "phasemap.mahadasha_sub": "आपके जीवन की पूरी रेखा — 9 महादशाएँ",
    "phasemap.antardasha_title": "अंतर्दशा फेज़ मानचित्र",
    "phasemap.antardasha_sub": "{planet} महादशा के 9 उप-काल",
    "phasemap.current": "वर्तमान",
    "phasemap.years": "वर्ष",
    "phasemap.tap_details": "विवरण के लिए किसी भी कार्ड पर टैप करें",

    "detail.what_asks": "यह काल क्या माँगता है",
    "detail.watch_for": "किस पर ध्यान दें",
    "detail.favors": "यह काल अनुकूल है",
    "detail.duration": "अवधि",
    "detail.start": "आरम्भ",
    "detail.end": "समाप्ति",
    "detail.years_word": "वर्ष",
    "detail.days_word": "दिन",
    "detail.you_are_here": "आप यहाँ हैं",

    "mission.your_mission": "आपका मिशन",
    "mission.progress": "प्रगति",
    "mission.duration": "अवधि",
    "mission.milestones": "मील के पत्थर",
    "mission.days": "दिन",
    "mission.complete_subtask": "उप-कार्य पूर्ण करें",
    "mission.saving": "सहेज रहे हैं…",
    "mission.complete_title": "मिशन पूर्ण",
    "mission.complete_sub": "आपने पूरा मार्ग चला। अगले अध्याय से पहले विश्राम करें।",
    "mission.step": "चरण",

    "menu.title": "सेटिंग्स",
    "menu.account": "खाता",
    "menu.subscription": "सब्सक्रिप्शन",
    "menu.preferences": "प्राथमिकताएँ",
    "menu.privacy": "गोपनीयता और डेटा",
    "menu.about": "Vedari के बारे में",
    "menu.plan": "योजना",
    "menu.plan_value": "नि:शुल्क परीक्षण",
    "menu.trial_ends": "परीक्षण समाप्त",
    "menu.upgrade": "अपग्रेड",
    "menu.coming_soon": "जल्द आ रहा है",
    "menu.plan_active_monthly": "Vedari मासिक",
    "menu.plan_active_yearly": "Vedari वार्षिक",
    "menu.plan_reviewer": "समीक्षक एक्सेस",
    "menu.plan_expired": "परीक्षण समाप्त",
    "menu.renews_on": "नवीनीकरण",
    "menu.ends_on": "एक्सेस तक",
    "menu.subscribe_now": "सदस्यता लें",
    "menu.see_plans": "योजनाएँ देखें",
    "menu.manage_play": "Play Store में प्रबंधित करें",
    "menu.subscribed_to": "सदस्य",
    "menu.auto_renew_on": "स्वचालित नवीनीकरण चालू",
    "menu.auto_renew_off": "स्वचालित नवीनीकरण बंद",
    "menu.theme": "थीम",
    "menu.language": "भाषा",
    "menu.notifications": "सूचनाएँ",
    "menu.email_only": "केवल ईमेल",
    "menu.export_data": "मेरा डेटा निर्यात करें",
    "menu.export_pdf": "डायरी PDF के रूप में निर्यात करें",
    "menu.delete": "मेरा खाता हटाएँ",
    "menu.approach": "हमारा दृष्टिकोण",
    "menu.privacy_link": "गोपनीयता नीति",
    "menu.terms": "सेवा की शर्तें",
    "menu.version": "ऐप संस्करण",
    "menu.signout": "साइन आउट",
    "menu.theme_light": "हल्का",
    "menu.theme_dark": "गहरा",

    "practice.heading": "आज का अभ्यास",
    "practice.mark_done": "पूर्ण के रूप में चिह्नित करें",
    "practice.done": "पूर्ण",
    "practice.minutes": "{n} मिनट",
    "practice.streak": "{n} दिन की लय",
    "practice.ack": "{n} दिन। शांत-सी उल्लेखनीयता।",

    "phase.what_asks": "यह काल आपसे क्या माँगता है",
    "phase.how_to_walk": "इसे अच्छे से कैसे चलें",
    "phase.critical_window": "महत्वपूर्ण समय",
    "phase.protect": "किसकी रक्षा करें",
    "phase.build": "क्या बनाएँ",
    "phase.how_showing_up": "आपके लिए यह कैसे प्रकट हो रहा है",
    "phase.theme": "विषय",
    "phase.refreshed": "इस अध्याय की आपकी समझ गहरी हुई है।",

    "progress.practices": "आपके अभ्यास",
    "progress.current_streak": "वर्तमान लय",
    "progress.longest_streak": "सबसे लम्बी लय",
    "progress.total_completed": "कुल पूर्ण",
    "progress.recent_practices": "हाल के अभ्यास",
    "progress.by_category": "श्रेणी अनुसार",
    "progress.cat_morning": "प्रातः",
    "progress.cat_day_of_week": "दिनानुसार",
    "progress.cat_phase": "काल-अनुरूप",
    "progress.cat_evening": "सायं",
    "progress.cat_weekly": "साप्ताहिक",
    "progress.cat_seasonal": "ऋतु",

    // Onboarding — Profile
    "ob.profile.title": "आपके बारे में थोड़ा",
    "ob.profile.sub": "ये विवरण हमें आपका सही ढंग से स्वागत करने में मदद करते हैं। यहाँ कुछ भी साझा नहीं किया जाता।",
    "ob.profile.name": "नाम",
    "ob.profile.name_ph": "आपका नाम",
    "ob.profile.age": "आयु",
    "ob.profile.age_ph": "वर्ष",
    "ob.profile.gender": "लिंग",
    "ob.profile.gender.male": "पुरुष",
    "ob.profile.gender.female": "स्त्री",
    "ob.profile.gender.nb": "नहीं बताना चाहते",
    "ob.profile.marital": "वैवाहिक स्थिति",
    "ob.profile.marital.single": "अविवाहित",
    "ob.profile.marital.married": "विवाहित",
    "ob.profile.marital.divorced": "तलाक़शुदा",
    "ob.profile.marital.widowed": "विधुर/विधवा",
    "ob.profile.marital.separated": "अलग रह रहे",
    "ob.profile.children": "संतान",
    "ob.profile.children_yes": "हाँ, मेरे बच्चे हैं",
    "ob.profile.children_count_ph": "कितने?",
    "ob.profile.city": "शहर",
    "ob.profile.city_ph": "आपका शहर",
    "ob.profile.profession": "व्यवसाय (वैकल्पिक)",
    "ob.profile.profession_ph": "आप क्या करते हैं",
    "ob.profile.language_prompt": "भाषा",

    // Onboarding — Priorities
    "ob.prio.title": "किनके साथ चलना चाहते हैं?",
    "ob.prio.sub_a": "अधिकतम चुनें",
    "ob.prio.sub_b": "। शुरुआत के लिए तीन अच्छी संख्या है।",
    "ob.prio.count": "5 में से {a} चुने गए",

    // Onboarding — DeepDive
    "ob.dive.of": "में से",
    "ob.dive.sub": "तीन छोटे प्रश्न। सावधान नहीं — ईमानदार रहें।",
    "ob.dive.rate_label": "आज इस क्षेत्र को आप कैसा आँकेंगे?",
    "ob.dive.rate_low": "संघर्षरत",
    "ob.dive.rate_high": "उन्नत",
    "ob.dive.heart_label": "इसके मूल में क्या है?",
    "ob.dive.note_label": "और कुछ कहने योग्य?",
    "ob.dive.note_opt": "(वैकल्पिक)",
    "ob.dive.note_ph": "एक-दो पंक्तियाँ",

    // Onboarding — Life Letter
    "ob.letter.title": "आपकी जन्म-पत्री देखने से पहले — हमें बताइए कि वास्तव में क्या चल रहा है।",
    "ob.letter.sub": "Vedari जितना अधिक आपके वर्तमान जीवन को जानेगा, उतना ही विशेष आपका मार्गदर्शन होगा। जितना चाहें उतना लिखें — तीनों प्रश्न वैकल्पिक हैं।",
    "ob.letter.q1_label": "अभी आपका जीवन कैसा है?",
    "ob.letter.q1_helper": "काम, रिश्ते, परिवार, स्वास्थ्य, धन, मनोदशा — जो आज सच लगे।",
    "ob.letter.q2_label": "सबसे कठिन बात कौन-सी है?",
    "ob.letter.q2_helper": "जो रात तीन बजे जगाती है। जो बातचीत आप टालते रहते हैं। जो निर्णय आप ले नहीं पाते।",
    "ob.letter.q3_label": "एक वर्ष बाद आप कहाँ होना चाहते हैं?",
    "ob.letter.q3_helper": "सूची-बद्ध लक्ष्य नहीं — उस जीवन का वास्तविक स्वरूप जिसमें आप वास्तव में बढ़े हुए दिखें।",
    "ob.letter.privacy": "जो भी आप लिखते हैं वह निजी रहता है। Vedari इसका उपयोग केवल आपके मार्गदर्शन को विशेष बनाने में करता है। आप इसे कभी भी सेटिंग्स से बदल या हटा सकते हैं।",
    "ob.letter.saving": "सहेज रहे हैं…",
    "ob.letter.skip": "बाद में जोड़ूँगा",
    "ob.letter.ph": "यहाँ लिखें, या छोड़ दें…",

    // Onboarding — Birth
    "ob.birth.title": "आपके जन्म का विवरण",
    "ob.birth.sub": "आपकी वैदिक कुण्डली की गणना के लिए। एन्क्रिप्टेड। कभी साझा नहीं।",
    "ob.birth.dob": "जन्म तिथि",
    "ob.birth.tob": "जन्म समय",
    "ob.birth.time_unknown": "मुझे सटीक समय का नहीं पता",
    "ob.birth.time_warning": "अनुमानित जन्म समय से दशा-काल की सीमाएँ कम सटीक होती हैं। आपकी कुण्डली फिर भी काम करेगी — कुछ अंतर्दृष्टि कम सटीक होगी।",
    "ob.birth.place": "जन्म स्थान",
    "ob.birth.place_ph": "शहर, देश",
    "ob.birth.preparing": "आपका मानचित्र तैयार हो रहा है…",
    "ob.birth.reveal": "मेरा वैदिक मानचित्र देखें",
    "ob.birth.cant_save": "आपका विवरण सहेजा नहीं जा सका। कृपया पुनः प्रयास करें।",

    "common.continue": "जारी रखें",
    "common.back": "वापस",
    "common.moment": "एक क्षण…",
  },
};

export function translate(lang, key, params = {}) {
  const table = STRINGS[lang] || STRINGS.en;
  let str = table[key] ?? STRINGS.en[key] ?? key;
  Object.entries(params).forEach(([k, v]) => {
    str = str.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
  });
  return str;
}

// Planet & nakshatra name translations (Devanagari).
const PLANET_HI = {
  Sun: "सूर्य",
  Moon: "चन्द्र",
  Mars: "मंगल",
  Mercury: "बुध",
  Jupiter: "गुरु",
  Venus: "शुक्र",
  Saturn: "शनि",
  Rahu: "राहु",
  Ketu: "केतु",
};

export function planetName(name, lang) {
  if (lang !== "hi" || !name) return name;
  return PLANET_HI[name] || name;
}

const NAKSHATRA_HI = {
  Ashwini: "अश्विनी", Bharani: "भरणी", Krittika: "कृत्तिका", Rohini: "रोहिणी",
  Mrigashira: "मृगशिरा", Ardra: "आर्द्रा", Punarvasu: "पुनर्वसु", Pushya: "पुष्य",
  Ashlesha: "आश्लेषा", Magha: "मघा", "Purva Phalguni": "पूर्व फाल्गुनी",
  "Uttara Phalguni": "उत्तर फाल्गुनी", Hasta: "हस्त", Chitra: "चित्रा", Swati: "स्वाति",
  Vishakha: "विशाखा", Anuradha: "अनुराधा", Jyeshtha: "ज्येष्ठा", Mula: "मूल",
  "Purva Ashadha": "पूर्वाषाढ़ा", "Uttara Ashadha": "उत्तराषाढ़ा", Shravana: "श्रवण",
  Dhanishta: "धनिष्ठा", Shatabhisha: "शतभिषा", "Purva Bhadrapada": "पूर्व भाद्रपद",
  "Uttara Bhadrapada": "उत्तर भाद्रपद", Revati: "रेवती",
};

export function nakshatraName(name, lang) {
  if (lang !== "hi" || !name) return name;
  return NAKSHATRA_HI[name] || name;
}

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
];
